var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('page-header',{attrs:{"title":_vm.title,"logo":_vm.logo}}),_c('container',[_vm._t("default")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }